<template>
  <div style="margin: 0 40px 8px 24px;">
    <el-form ref="formRef" label-width="auto" label-position="right">
      <el-form-item label="微信号：" v-if="type == 1">
        <el-input v-model="wechat" placeholder="请输入总部微信号" />
      </el-form-item>
      <el-form-item label="咨询时间：" v-if="type == 2">
        <el-space>
          <el-time-select
              v-model="startTime"
              style="width: 150px"
              :max-time="endTime"
              class="mr-4"
              placeholder="Start time"
              start="08:30"
              step="00:15"
              end="23:30"
          />
          <el-time-select
              v-model="endTime"
              style="width: 150px"
              :min-time="startTime"
              placeholder="End time"
              start="08:30"
              step="00:15"
              end="23:30"
          />
        </el-space>
      </el-form-item>
      <el-form-item label="二维码：">
        <div>
          <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { updateSysWechat } from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      wechatForm: this.value.wechatForm,
      idx: this.value.ids,
      type: this.value.type,

      files: null,
      src: this.value.wechatForm?this.value.wechatForm.wechatImg:'',
      wechat: this.value.wechatForm?this.value.wechatForm.wechat:'',

      startTime: '',
      endTime: ''

    }
  },
  methods: {

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.wechat && this.type == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '微信号不能为空',
          type: 'warning'
        });
        return false
      }

      let param = new FormData();
      param.append('type', this.type);
      param.append('openTime', this.startTime + '~' + this.endTime);
      param.append('wechat', this.wechat);
      param.append('file', this.files);

      imgPostFormData(updateSysWechat, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {
    if(this.type == 2 && this.wechatForm.openTime) {
      let arr = this.wechatForm.openTime.split('~')
      this.startTime = arr[0]
      this.endTime = arr[1]
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
